<script lang="ts">
  import NavLeftIcon from "../icons/NavLeftIcon.svelte";
  import NavRightIcon from "../icons/NavRightIcon.svelte";

  export let nextDisabled: boolean;
  export let previousDisabled: boolean;
  export let onNext: () => void;
  export let onPrevious: () => void;
</script>

<div class="container">
  <button on:click={onPrevious} disabled={previousDisabled}>
    <NavLeftIcon />
  </button>

  <button on:click={onNext} disabled={nextDisabled}>
    <NavRightIcon />
  </button>
</div>

<style>
  .container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 64px;
    height: 40px;
    border-radius: 100px;
    background-color: #3f3f3fcc;
    padding: 8px;
  }

  button {
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: center;
    pointer-events: all;
  }
  button:disabled {
    opacity: 0.5;
  }
</style>
